import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnerPageTemplate from "@/components/partners/PartnerPageTemplate";
import { neighborworks } from "@/data/partners";

export const Route = createFileRoute("/partners/neighborworks")({
  head: () => seoHead("/partners/neighborworks"),
  component: () => <PartnerPageTemplate partner={neighborworks} />,
});
